import React from 'react';
import {connect} from "dva";
import {IntlProvider} from "react-intl";

import zh_CN from "../../locale/zh_CN"; // 中文
import es_Es from "../../locale/es_ES" // 西班牙语
import en_US from "../../locale/en_US" // 西班牙语
import de_DE from "../../locale/de_DE"; // 德语
import fr_FR from "../../locale/fr_FR"; // 法语
import ar_SA from "../../locale/ar_SA"; // 阿拉伯语
import ru_RU from "../../locale/ru_RU"; // 俄语
import ms_MY from "../../locale/ms_MY"; // 马来语
import vi_VN from "../../locale/vi_VN"; // 越南语
import th_TH from "../../locale/vi_VN"; // 泰语
import id_ID from "../../locale/id_ID"; // 印尼语
// 多语言
const messages = {
    'zh': zh_CN,
    'es': es_Es,
    'en': en_US,
    'de': de_DE,
    'fr': fr_FR,
    'ar': ar_SA,
    'ru': ru_RU,
    'ms': ms_MY,
    'vi': vi_VN,
    'th': th_TH,
    'id': id_ID,
};

@connect(state => ({...state.appModel}))
class IntlLayout extends React.Component {
    render() {
        const {lang = 'zh'} = this.props || {};
        return (
            <IntlProvider locale={lang} messages={messages[lang]}>
                {this.props.children}
            </IntlProvider>
        )
    }
};
export default IntlLayout
